import { Box } from '@chakra-ui/react';
export default function Auth(props) {
	const { children } = props;
	return (
		<Box
			mx='auto'
			minH='100vh'
		>
			{children}
		</Box>
	);
}
